import { useMappedParams } from '../../hooks/utils';

export function usePresenterParams() {
  return useMappedParams({
    eventId: (params) => +params.event_id,
    sessionId: (params) => +params.session_id,
    moduleId: (params) => +params.module_id,
  });
}
